import { useIsMinTabletSize } from "~/common/hooks/useMediaQuery";
import ConfirmationModal from "~/common/components/ConfirmationModal";
import classNames from "classnames";
import { Trans, useTranslation } from "react-i18next";

interface ModalProps {
  onClose: () => void;
  onSubmit: () => void;
  selectedValue: string;
  inputField: string;
}

export const ModalConfirmation = ({ onClose, onSubmit, selectedValue, inputField }: ModalProps) => {
  const { t } = useTranslation();

  const ok = t("page.completeRegistration.submit");
  const cancel = t("contactUsPage.form.cancel");
  return (
    <ConfirmationModal
      okLabel={ok}
      cancelLabel={cancel}
      onCancel={onClose}
      onOk={onSubmit}
    >
      <div className={"mb-4"}>
        <Trans i18nKey={"myAccount.customerCategory.popup.message"}>
          You have chosen <strong>{{ selected: selectedValue }}</strong> as your <strong>{{ type: inputField }}</strong>
          <br />
          Please note that once submitted, further changes to the {{ typeField: inputField }} will not be possible.
          Would you like to proceed?
        </Trans>
      </div>
    </ConfirmationModal>
  );
};
